import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import AddressProp from '../../../../commonComponents/propTypes/addressProp';
import CustomRadio from '../../../../commonComponents/forms/inputs/CustomRadio';
import FormattedAddress from '../../FormattedAddress';

// Formatting address
const handleAddress = (address, formatAddress = true) => {
  if (formatAddress) {
    return (
      <FormattedAddress
        address={address}
        showOptionalFields
        formatName
      />
    );
  }
  return `${address.address_1}, ${address.address_2 ?
    `${address.address_2}, `
    : ''} ${address.city} ${address.zipCode}, ${address.country}`;
};

const PayOrderAddress = props => {
  const { t, id, address, label, isProvider, shippingProvider, formatAddress, isPickupLocation } = props;

  return (
    <div className="m-invoice-2 products-toPay shipping-toPayContainer">
      <h3 className="products-toPay-title">{label}</h3>
      <div className="row shipping-toPay row">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <div className="radio-container">
          <CustomRadio
            id={id}
            onChange={() => {}}
            onClick={() => {}}
            checked
          />
        </div>
        <div className="shipping-toPay-content">
          {isProvider && (<h6>{(shippingProvider?.name || '')}</h6>)}
          {isPickupLocation && (<h6>{t('shop.pickupLocationName')}</h6>)}
          <p>{!isProvider ? handleAddress(address, formatAddress) : (shippingProvider?.description || '')}</p>
        </div>
      </div>
    </div>
  );
};

PayOrderAddress.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  address: PropTypes.shape(AddressProp.propType),
  label: PropTypes.string.isRequired,
  isProvider: PropTypes.bool,
  shippingProvider: PropTypes.bool,
  formatAddress: PropTypes.bool,
  isPickupLocation: PropTypes.bool,
};

PayOrderAddress.defaultProps = {
  address: null,
  isProvider: false,
  isPickupLocation: false,
  formatAddress: true,
  shippingProvider: null,
};

export default compose(
  translate,
)(PayOrderAddress);
